import styled from '@emotion/styled';

export default styled('div')`
  font-size: 20px;
  padding: 10px 0;
`;
